import * as React from "react";
import { H2 } from "main/javascripts/components/atoms/H2";
import { Paragraph } from "main/javascripts/components/atoms/Paragraph";

export interface IProps {
  description: string | null;
}

export const Description: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> | null => {
  if (!props.description) {
    return null;
  }
  return (
    <div>
      <H2>紹介</H2>
      <Paragraph>{props.description}</Paragraph>
    </div>
  );
};
